import React from 'react';
import { cn } from '@/lib/utils';

export const PageHeader = ({ title, description, actions, className }) => (
  <div className={cn('flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-6', className)}>
    <div>
      <h1 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight">{title}</h1>
      {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
  </div>
);
